import orderUtils from 'utils/Order';

/**
 * Returns whether PayPal is the active payment method.
 *
 * PayPal selection is derived from the presence of the PayPal payment group plus a defined
 * `priceInfo.paypalAmount` (not `paymentGroup.isComplete`). The PayPal payment group is only marked
 * complete after approval in the PayPal Sheet, but the UI needs to know the active method beforehand.
 * The `paypalAmount` check also covers the swap-to-credit-card flow where the payment group may remain
 * on the order but `paypalAmount` is cleared.
 *
 * @param {Object} orderDetails
 * @param {Object} priceInfo
 * @returns {boolean}
 */

const isPayPalActivePaymentMethod = (orderDetails, priceInfo) => {
    const payPalPaymentGroup = orderUtils.getPayPalPaymentGroup(orderDetails);

    return !!payPalPaymentGroup && priceInfo?.paypalAmount !== undefined;
};

export default isPayPalActivePaymentMethod;
